export default {
  toasts: {
    load_error: 'Falha ao carregar a configuração de pagamento',
    rails_saved: 'Vias de pagamento guardadas',
    gateway_registered: 'Gateway registado',
    redact_failed: 'Falha ao expurgar o gateway',
    gateway_redacted: 'Gateway expurgado',
    sca_provisioned: 'Registo 3DS2 criado',
    company_assigned: 'Restaurante atribuído',
    default_set: 'Gateway predefinido definido — os novos restaurantes serão atribuídos a ele automaticamente',
    default_failed: 'Falha ao definir o gateway predefinido',
    primary_switched: 'Gateway principal alterado para {{gateway}}',
    primary_switch_failed: 'Falha ao alterar o gateway principal',
  },
  custody: {
    title: 'Quem processa os pagamentos',
    description:
      'Decidido uma vez, ao guardar a primeira via, e bloqueado depois: com o próprio gateway, o parceiro detém os fundos; na conta Adyen da FoodAmigos, a FoodAmigos detém-nos e paga a parte do parceiro mensalmente.',
    options: {
      provider: 'Gateway próprio do parceiro',
      platform: 'A FoodAmigos processa os pagamentos',
    },
    locked_notice: 'Bloqueado em “{{custodian}}” pela configuração de pagamento — não pode ser alterado.',
    pick_first: 'Escolha primeiro quem processa os pagamentos.',
    lock_confirm: {
      title: 'Bloquear pagamentos a “{{custodian}}”?',
      description:
        'Ao guardar, decide agora quem vai gerir os fundos deste parceiro, e isso não pode ser revertido — nem por si, nem pelo suporte. O canal de pagamento ainda pode ser alterado mais tarde; quem processa os pagamentos não pode.',
      confirm: 'Bloquear e guardar',
    },
  },
  rails: {
    title: 'Via de pagamento',
    description:
      'Em qual processador este parceiro opera — apenas um de cada vez. Os restaurantes só podem ser mudados para a via aqui selecionada, e uma via não pode ser substituída enquanto restaurantes ainda cobrarem nela.',
    save: 'Guardar via',
    multiple_warning:
      'Este parceiro ainda opera em mais do que uma via ({{rails}}). Guardar mantém apenas a selecionada acima; as restantes são removidas, e a alteração é recusada de imediato se algum restaurante ainda cobrar numa delas.',
    options: {
      stripe: 'Stripe',
      adyen: 'Adyen',
      spreedly: 'Gateway local via Spreedly',
    },
    platform_stripe_unavailable: 'O Stripe nas contas FoodAmigos ainda não está disponível.',
    platform_custody_notice: 'Não disponível quando é a FoodAmigos a processar os pagamentos.',
    provider_custody_adyen_notice:
      'Não disponível quando o parceiro usa o seu próprio gateway — a Adyen é a via de processamento da FoodAmigos.',
  },
  spreedly_section_title: 'Configuração do Spreedly',
  gateways: {
    title: 'Gateways',
    description:
      'As próprias contas PSP do parceiro. A totalidade da cobrança é liquidada no adquirente do gateway selecionado.',
    register: 'Registar gateway',
    empty: 'Ainda não há gateways registados',
    columns: {
      gateway: 'Gateway',
      status: 'Estado',
      sca: '3DS2',
      companies: 'Restaurantes',
    },
    statuses: {
      active: 'Ativo',
      redacted: 'Expurgado',
    },
    sca: {
      sandbox: 'Sandbox 3DS2',
      live: '3DS2 em produção',
      none: 'Sem 3DS2',
    },
    default_tag: 'Predefinido',
    actions: {
      make_default: 'Definir como predefinido',
      check: 'Executar verificação…',
      sca_provision: 'Configurar 3DS2…',
      sca_manage: 'Registo 3DS2…',
      redact: 'Expurgar gateway',
    },
  },
  redact_confirm: {
    title: 'Expurgar {{gateway}}?',
    description:
      'As credenciais são eliminadas no Spreedly e não podem ser recuperadas. {{count}} restaurante(s) atribuído(s) ainda cobra(m) através deste gateway — enquanto houver algum atribuído, a expurgação é recusada e é-lhe pedida confirmação novamente.',
    redact: 'Expurgar',
    force_title: 'Expurgar {{gateway}} mesmo assim?',
    force_description:
      '{{count}} restaurante(s) ainda estão atribuídos a este gateway. Expurgá-lo agora impedirá o checkout desses restaurantes até que cada um seja atribuído a outro gateway. Esta ação não pode ser revertida.',
    force_redact: 'Expurgar mesmo assim',
  },
  companies: {
    title: 'Restaurantes',
    description: 'O processador através do qual cada restaurante cobra, e a respetiva atribuição de gateway Spreedly.',
    empty: 'Sem restaurantes',
    no_gateway: 'Nenhum',
    unassigned: 'Não atribuído',
    // The default gateway is assigned at creation and never fails the creation —
    // so a restaurant can end up unassigned with the reason only in the log.
    assignment_error_label: 'Falha na atribuição automática',
    assign: 'Atribuir',
    reassign: 'Reatribuir',
    columns: {
      restaurant: 'Restaurante',
      primary_gateway: 'Gateway principal',
      spreedly: 'Gateway Spreedly',
    },
    switch_primary_to: 'Mudar para {{gateway}}',
    assign_modal: {
      title: 'Atribuir {{company}} a um gateway',
      assign: 'Atribuir',
      gateway: 'Gateway',
      make_primary: 'Também tornar o Spreedly o gateway principal',
      make_primary_hint: 'As cobranças só são encaminhadas pelo Spreedly enquanto este for o gateway principal.',
    },
  },
  register_modal: {
    title: 'Registar um gateway',
    register: 'Registar',
    gateway_type: 'Tipo de gateway',
    gateway_type_placeholder: 'Pesquisar no catálogo do Spreedly…',
    auth_mode: 'Modo de autenticação',
    no_credentials: 'Este tipo de gateway não precisa de credenciais (sandbox Spreedly).',
    description: 'Descrição',
    description_placeholder: 'ex.: Acme Eats — Braintree EUR',
    acquirer_merchant_id: 'ID de comerciante do adquirente',
    acquirer_hint: 'Opcional — necessário em conjunto com o MCC',
    mcc: 'MCC',
    mcc_hint: '4 dígitos, ex.: 5812',
    make_default: 'Utilizar como predefinição do parceiro',
    make_default_hint:
      'Os novos restaurantes do parceiro, e os que ainda não têm gateway, ficam associados a esta. Deixe por assinalar se for o adquirente próprio de um restaurante.',
  },
  sca_modal: {
    title: 'Registo 3DS2 — {{gateway}}',
    provision: 'Aprovisionar',
    irreversible_warning:
      'Irreversível: nem o perfil do comerciante nem o fornecedor SCA podem ser editados ou eliminados posteriormente. Um BIN de adquirente incorreto só se manifesta no momento da cobrança. Confirme todos os valores com o banco adquirente antes de aprovisionar.',
    already_provisioned:
      'Já aprovisionado (token do fornecedor {{token}}). Aprovisionar novamente devolve o registo existente, salvo se a opção Recriar estiver ativada.',
    type: {
      label: 'Tipo de fornecedor',
      hint: '“Teste” simula resultados de autenticação e é rejeitado em produção.',
      test: 'Teste (sandbox SCA)',
      live: 'Produção (Spreedly 3DS2 Global)',
    },
    country: {
      hint: 'O país sob o qual o banco adquirente registou este comerciante — não necessariamente onde o parceiro está sedeado. Aplica-se a todas as redes de cartões abaixo.',
      differs_warning:
        'Este não é o país do parceiro ({{country}}). Corrija se o adquirente registou o comerciante noutro local; caso contrário, verifique, pois um perfil de comerciante não pode ser editado depois de criado.',
    },
    network_placeholder: 'Rede do cartão',
    add_network: 'Adicionar rede de cartão',
    networks: {
      visa: 'Visa',
      mastercard: 'Mastercard',
      amex: 'American Express',
      discover: 'Discover',
      diners: 'Diners',
      jcb: 'JCB',
      dankort: 'Dankort',
      union_pay: 'UnionPay',
      cartes_bancaires: 'Cartes Bancaires',
    },
    fields: {
      acquirer_merchant_id: 'ID de comerciante do adquirente',
      acquirer_bin: 'BIN do adquirente',
      mcc: 'MCC',
      merchant_name: 'Nome do comerciante',
      country_code: 'País (ISO-2)',
      merchant_url: 'URL do comerciante',
    },
    recreate: {
      label: 'Recriar o registo',
      hint: 'Abandona definitivamente o perfil de comerciante e o fornecedor SCA atuais e cria novos.',
    },
  },
  check_modal: {
    title: 'Verificar gateway — {{gateway}}',
    run: 'Executar verificação',
    done: 'Concluído',
    failed: 'Não foi possível executar a verificação.',
    types: {
      verify: 'Verificar (sem movimentação de dinheiro)',
      test_payment: 'Pagamento de teste',
    },
    verify_unsupported: 'Este tipo de gateway não suporta verificação — execute um pagamento de teste.',
    test_payment_warning:
      'É efetuada uma cobrança real num gateway ativo e reembolsada de imediato. Em gateways de mercados SCA, o emissor pode recusar o teste sem 3DS — isso ainda comprova que as credenciais chegaram ao adquirente.',
    amount: 'Valor',
    amount_help: 'Entre 1,00 e 5,00',
    check_passed: 'Verificação aprovada',
    check_failed: 'Verificação falhou — ver os passos abaixo',
    legs: {
      verify: 'Verificação',
      purchase: 'Cobrança',
      credit: 'Reembolso',
    },
    leg_passed: 'Aprovado',
    leg_failed: 'Falhou',
  },
  card_fields: {
    script_failed: 'Não foi possível carregar o script do Spreedly. Verifique a rede e tente novamente.',
    full_name: 'Nome do titular do cartão',
    number: 'Número do cartão',
    expiry: 'Validade',
    cvv: 'CVV',
  },
};
